"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditionActiveImage = void 0;

var _styles = require("./styles");

var _index = require("../../atoms/ProductImage/index");

var _index2 = require("../../atoms/GeneralButton/index");

var _jsxRuntime = require("react/jsx-runtime");

var EditionActiveImage = function EditionActiveImage(_ref) {
  var img = _ref.img,
      altText = _ref.altText,
      setShowModal = _ref.setShowModal;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ProductImage, {
      img: img,
      imageType: "main-image",
      altText: altText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.Button, {
      buttonType: "open-modal-button",
      onClick: function onClick() {
        return setShowModal(true);
      }
    })]
  });
};

exports.EditionActiveImage = EditionActiveImage;